import request from "root/js/request";

export const getWarehouseByOrder = async ({
  cabinet_id,
  date_from,
  date_to,
  period,
  in_subject_id,
  in_subject_id__in,
  in_brand_id,
  in_brand_id__in,
  in_barcode_id,
  in_barcode_id__in,
  in_product_id,
  in_product_id__in,
  source__in,
  ...rest
}) => {
  const response = await request({
    url: "/analytics/cross-mp/warehouse_by_order/",
    method: "get",
    params: {
      cabinet_id,
      date_from,
      date_to,
      period,
      in_subject_id,
      in_subject_id__in,
      in_brand_id,
      in_brand_id__in,
      in_barcode_id,
      in_barcode_id__in,
      in_product_id,
      in_product_id__in,
      source__in,
      ...rest,
    },
  });
  return response.data;
};
